// import React, { useEffect, useState } from 'react';

// const NUM_CARDS = 5;
// const INTERVAL_MS = 1500;

// const AnimatedCard: React.FC = () => {
//     const [cardOrder, setCardOrder] = useState<number[]>(Array.from({ length: NUM_CARDS }, (_, i) => i));

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCardOrder((prevOrder) => {
//                 const newOrder = [...prevOrder];
//                 const first = newOrder.shift();
//                 if (first !== undefined) {
//                     newOrder.push(first); // move top card to the back
//                 }
//                 return newOrder;
//             });
//         }, INTERVAL_MS);

//         return () => clearInterval(interval);
//     }, []);

//     const containerStyle: React.CSSProperties = {
//         position: 'relative',
//         width: '300px',
//         height: '400px',
//         margin: '50px auto',
//         perspective: '1000px',
//     };

//     const getCardStyle = (i: number): React.CSSProperties => {
//         const translateY = -30 * i;
//         const scale = 1 - i * 0.05;
//         return {
//             width: '100%',
//             height: '100%',
//             background: 'linear-gradient(135deg, #c3cfe2, #ddeeff)',
//             borderRadius: '12px',
//             boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             fontSize: '24px',
//             fontWeight: 'bold',
//             position: 'absolute',
//             bottom: 0,
//             zIndex: NUM_CARDS - i,
//             transform: `translateY(${translateY}px) scale(${scale})`,
//             transition: 'transform 0.8s ease',
//         };
//     };

//     return (
//         <div style={containerStyle}>
//             {cardOrder.map((cardIndex, i) => (
//                 <div key={cardIndex} style={getCardStyle(i)}>
//                     <h3>Card {cardIndex + 1}</h3>
//                 </div>
//             ))}
//         </div>
//     );
// };

// export default AnimatedCard;
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const IMAGES = ["/assets/f1.svg", "/assets/f2.svg", "/assets/f3.svg"];
const MOBILE_IMAGES = [
  "/assets/90679411.svg",
  "/assets/90679412.svg",
  "/assets/90679413.svg",
];
const INTERVAL_MS = 3500;

const AnimatedCard: React.FC = () => {
  const [imageOrder, setImageOrder] = useState<number[]>([0, 1, 2]);
  const [animating, setAnimating] = useState(false);
  const [isMobile, ] = useState(window.innerWidth <= 768);
  const [paused, setPaused] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const longPressTimer = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();

  const startAnimation = () => {
    intervalRef.current = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setImageOrder((prev) => {
          const newOrder = [...prev];
          const first = newOrder.shift();
          if (first !== undefined) newOrder.push(first);
          return newOrder;
        });
        setAnimating(false);
      }, 700);
    }, INTERVAL_MS);
  };

  const stopAnimation = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    if (!paused) startAnimation();
    return () => stopAnimation();
  }, [paused]);

  const handleLongPressStart = () => {
    longPressTimer.current = setTimeout(() => {
      setPaused(true);
    }, 500); // Adjust press duration as needed
  };

  const handleLongPressEnd = () => {
    if (longPressTimer.current) clearTimeout(longPressTimer.current);
    setPaused(false);
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setPaused((prev) => !prev); // toggle pause on right click
  };
  const handleClick = () => {
    window.scrollTo(0, 0); // Scroll to top
    navigate("/contact-sales"); // Navigate to the desired route
  };

  const containerStyle: React.CSSProperties = {
    position: "relative",
    width: "1100px",
    height: "600px",
    perspective: "1500px",
  };

  const getCardStyle = (i: number): React.CSSProperties => {
    const isTop = i === 0 && animating;
    const translateY = i * 60;
    const scale = 1 - i * 0.15;
    const zIndex = IMAGES.length - i;
    const opacity = 1 - i * 0.05;

    return {
      width: isMobile ? "92%" : "100%",
      marginTop: isMobile? "-320px":"-300px",
      height: isMobile ? "80%" : "100%",
      position: "absolute",
      top: 0,
      //   left: 0, //25
      left: isMobile ? 14 : 0,
      transform: isTop
        ? "translateY(-100px) rotateY(25deg) scale(0.5)"
        : `translateY(${translateY}px) scale(${scale})`,
      zIndex: isTop ? 0 : zIndex,
      opacity: isTop ? 0 : opacity,
      transition: "transform 0.7s ease, opacity 0.7s ease",
      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: "#fff",
      pointerEvents: i === 0 ? "auto" : "none",
    };
  };

  const imageStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  const buttonStyle: React.CSSProperties = {
    position: "absolute",
    bottom: "30px",
    height: "55px",
    left: "42px",
    padding: "10px 20px",
    backgroundColor: "white",
    color: "rgb(62, 25, 83)",
    border: "0.2px solid rgb(62, 25, 83)",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    zIndex: 2147483647,
  };

  const pageContainerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    width: "100%",
  };

  return (
    <div style={pageContainerStyle}>
      <div style={containerStyle}>
        {imageOrder.map((imgIndex, i) => (
          <div
            key={imgIndex}
            style={getCardStyle(i)}
            onTouchStart={handleLongPressStart}
            onTouchEnd={handleLongPressEnd}
            onMouseDown={handleLongPressStart}
            onMouseUp={handleLongPressEnd}
            onContextMenu={handleContextMenu}
          >
            <img
              src={isMobile ? MOBILE_IMAGES[imgIndex] : IMAGES[imgIndex]}
              alt={`Card ${imgIndex + 1}`}
              style={imageStyle}
            />
          {!isMobile && (
  <button style={buttonStyle} onClick={handleClick}>
    Unlock Now
  </button>
)}

          </div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedCard;